const en = {

    "front.faq.chat.title": "ASK A QUESTION",
    "front.faq.chat.description": "instant support for restaurant guests",
    "front.faq.chat.welcome": "Here you can ask a question directly.",
    "front.faq.chat.placeholder": "message",
    "front.faq.chat.send": "send",
    "front.faq.chat.unsupportedLanguage": "Entschuldigung, dieser Chat unterstützt derzeit nur Englisch und Deutsch.",
    "front.faq.chat.fallback": "Thank you for your message. At the moment, I can only answer common questions. Please contact us directly for more information.",

    "front.faq.chat.answer.hours": "We are open daily from 10:00 to 22:00.",
    "front.faq.chat.answer.reservation": "Yes, you can reserve a table directly on our website or by phone.",
    "front.faq.chat.answer.groupReservation": "For group reservations, please contact us directly so we can find the best option for you.",
    "front.faq.chat.answer.address": "Our address is: Musterstraße 1, Berlin.",
    "front.faq.chat.answer.parking": "Yes, parking is available nearby.",
    "front.faq.chat.answer.phone": "You can contact us at +49 000 000000.",
    "front.faq.chat.answer.payment": "Yes, you can pay in cash or by card.",
    "front.faq.chat.answer.menu": "You can find our current menu on the website. If you have questions about specific dishes, we will be happy to help.",
    "front.faq.chat.answer.vegetarian": "Yes, we offer vegetarian dishes.",
    "front.faq.chat.answer.vegan": "Yes, we also have vegan options on our menu.",
    "front.faq.chat.answer.allergens": "If you have allergies or intolerances, please contact us directly. We will be happy to provide information about ingredients.",
    "front.faq.chat.answer.takeaway": "Yes, food can also be ordered for takeaway.",
    "front.faq.chat.answer.delivery": "At the moment, we only support reservations and questions through the website.",
    "front.faq.chat.answer.terrace": "Yes, in good weather you can also sit on our terrace.",
    "front.faq.chat.answer.pets": "Please contact us directly if you would like to visit with a pet.",
    "front.faq.chat.answer.children": "Yes, families with children are very welcome.",
    "front.faq.chat.answer.wifi": "Yes, Wi-Fi is available for our guests.",

    "front.faq.chat.answer.hours": "",
    "front.faq.chat.answer.reservation": "",
    "front.faq.chat.answer.address": "",
    "front.faq.chat.answer.phone": "",
    "front.faq.chat.answer.delivery": "",


    "front.acquaintance.callback.placeholder": "Your phone number",
    "front.acquaintance.callback.send": "Send",
    "front.acquaintance.callback.sending": "Sending...",
    "front.acquaintance.callback.invalidPhone": "Please enter a valid phone number.",
    "front.acquaintance.callback.success": "Request sent. I will contact you soon.",
    "front.acquaintance.callback.error": "Error sending request. Please try again.",

    "front.landingSeo.links.digitalMenu": "Digital menu for restaurants",
    "front.landingSeo.links.qrMenu": "QR code menu for restaurants",
    "front.landingSeo.links.multilingualMenu": "Multilingual menu for restaurants",
    "front.landingSeo.links.reservation": "Online table reservation for restaurants",
    "front.landingSeo.links.freeDigitalMenu": "Test a free digital menu",
    "front.landingSeo.links.changeMenuOnline": "Change menu online",


    "menu.title": "Menu",
    "menu.promo": "Special offers",
    "menu.empty.categoryTitle": "Fill in category name",
    "menu.empty.itemTitle": "Fill in product name",
    "menu.empty.itemDescription": "Fill in product description",
    "cart.add": "Add to cart",
    "cart.cancel": "Cancel",
    "section.video": "Video presentation",
    "section.tables": "ONLINE TABLE RESERVATION",
    "section.table": "SELECT TABLE",
    "section.menu": "Restaurant menu",
    "section.faq": "FAQ",
    "section.contact": "Contact",
    "promo.buy": "Buy",

    "front.tenant.resolving": "Detecting restaurant by subdomain…",
    "front.tenant.notFound": "No client found for this subdomain",
    "front.tenant.resolveError": "Failed to resolve client",
    "front.menu.loading": "Loading…",
    "front.menu.loadError": "Failed to load menu",
    "front.menu.addtocart": "Cart",
    "front.menu.cancel": "Cansel",
    "front.Number.servings": "Number of servings",

    // 🔹 Orbit labels
    "orbit.menu": "MENU",
    "orbit.shef": "RESERVATION",
    "orbit.video": "VIDEO",
    "orbit.faq": "QUESTIONS",
    "orbit.interior": "INTERIOR",
    "orbit.footer": "SOCIAL MEDIA",

    // 🔹 ShefSection
    "shef.title.line1": "ONLINE",
    "shef.title.line2": "RESERVATION",
    "shef.banner.label": "Choose",
    "shef.banner.main": "your table",
    "shef.reserved": "RESERVED",

    //----VIDEO-----//
    "video.title": "THIS IS HOW WE COOK - HONESTLY AND DELICIOUSLY",
    "video.add": "Add video",
    "add.video.but":"Add",

    //-----INTERIOR-----//
    "interior.title": "OUR INTERIOR",

    //-----FOOTER------//
    "footer.kontact": "CONTACTS",

    //-----TELEGRAM------//
    "telegram.title": "To set up Telegram order notifications, you need to:",
    "telegram.title.first": "1. get BOT_TOKEN",
    "telegram.text.first": "To get a BOT_TOKEN, find and launch the @BotFather bot in Telegram, send the /newbot command, follow the instructions to create a unique bot name and username, and then copy the API token that @BotFather sends in response",
    "telegram.title.two": "2. Get CHAT_ID",
    "telegram.text.two": "To get CHAT_ID, find and launch the @UserInfoBot bot in Telegram, send the /start command, and then copy the ID you will receive in the reply message",

    // --- CART (Cart.jsx) ---
    "cart.title": "YOUR CART",
    "cart.header.aria": "Your cart",

    "cart.toggle.expand": "Expand cart",
    "cart.toggle.collapse": "Collapse cart",

    "cart.total.label": "Total",
    "cart.total.products": "products",

    "cart.button.primary": "order",
    "cart.button.back": "back",
    "cart.button.waiter": "WAITER",

    "cart.mode.takeaway": "take away",
    "cart.mode.tableTime": "Time & table",
    "cart.mode.tableTime.disabled": "no free tables",
    "cart.mode.tableTime.tooltip": "Time & table",
    "cart.mode.tableTime.tooltipNoFree": "no free tables",
    "cart.mode.inHouse": "in-house",

    "cart.bookingFlow.title": "RESERVATION. TABLE NUMBER",

    "cart.deposit.itemTitle": "Table reservation (Deposit)",
    "cart.deposit.lineTitle": "Deposit",
    "cart.deposit.badge": "Deposit {amount}€",

    "cart.table.msg.tempChosen": "Table {table} temporarily chosen ✓",
    "cart.table.msg.noFree": "Unfortunately there are no free tables",
    "cart.table.msg.chooseOrDefault": "Please choose a table or use the default selection.",

    "cart.table.select.reserved": "RESERVED",
    "cart.table.select.pick": "SELECT",
    "cart.table.select.any": "ANY",

    "cart.inHouse.title": "CHOOSE YOUR TABLE NUMBER",
    "cart.inHouse.select.placeholder": "Choose table",
    "cart.inHouse.select.option": "Table #{n}",

    "cart.checkout.back": "Back",

    "cart.payment.preparing": "Preparing payment…",
    "cart.loading": "Loading…",

    // --- MockCheckoutPanel (en) ---
    "mockCheckout.title.paymentMethod": "PAYMENT METHOD",

    "mockCheckout.method.card": "Card",
    "mockCheckout.method.paypal": "PayPal",
    "mockCheckout.method.gpay": "Google Pay",

    "mockCheckout.cardForm.title": "ENTER CARD DETAILS",
    "mockCheckout.cardForm.numberLabel": "CARD NUMBER",

    "mockCheckout.error.invalidCardNumber": "Invalid card number",
    "mockCheckout.error.enter16Digits": "Enter 16 digits",
    "mockCheckout.error.expiryFormat": "Format MM/YY",
    "mockCheckout.error.expiryMonthRange": "Month 01–12",
    "mockCheckout.error.cardExpired": "Card expired",
    "mockCheckout.error.cvc3Digits": "3 digits",

    "mockCheckout.error.sendTelegram": "Error sending to Telegram",
    "mockCheckout.error.generic": "Something went wrong",

    "mockCheckout.reserve.clientNotFound": "Client not found",
    "mockCheckout.reserve.tablesNotFound": "Client has no tables section",
    "mockCheckout.reserve.tableNotFound": "Table not found",
    "mockCheckout.reserve.alreadyReserved": "This table was just taken. Please choose another one.",
    "mockCheckout.reserve.noFreeTables": "No free tables available right now",
    "mockCheckout.reserve.tableNotSelected": "Please select a table",
    "mockCheckout.reserve.genericError": "Reservation error",

    "mockCheckout.button.back": "back",
    "mockCheckout.button.pay": "PAY",
    "mockCheckout.button.sending": "…sending",
    "mockCheckout.button.paid": "...",
    "mockCheckout.button.payInvalidTitle": "Please check the card fields",

    "admin.booking.lead.title": "MINIMUM RESERVATION TIME",
    "admin.booking.lead.note": "This affects guest reservations in 'table & time' mode only. Step is 30 minutes.",

    // DateTimeStep

    "dateTimeStep.select.time": "SELECT TIME",


    // ---------- ADMIN ----------
    "admin.title": "ADMIN PAGE",
    "admin.loading": "Loading…",
    "admin.nav.delete": "Delete",

    "admin.nav.back": "Back",
    "admin.nav.next": "NEXT",
    "admin.nav.confirm": "SAVE",
    "admin.nav.confirm.now": "saving ...",
    "admin.booking.settings": "Booking settings",
    "admin.booking.deposit": "DEPOSIT AMOUNT",
    "admin.booking.deposit.note": "Deposit charged when the guest books only a table",

    "admin.hub.editmenu": "EDIT MENU",
    "admin.hub.qr": "QR CODE",
    "admin.hub.prices": "YOUR RATE",
    "admin.hub.settings": "SETTINGS",

    "admin.panel.editmenu": "Edit menu",
    "admin.validation.required" : "Required field",
    "admin.panel.add": "Add position",
    "admin.panel.menu": "Edit menu list",
    "admin.panel.telegram": "Telegram",
    "admin.panel.table": "TABLE MANAGEMENT",
    "admin.set.table": "Halls / tables",
    "admin.set.logo": "Logo and backgrounds",
    "admin.logo.successfully.applied": "Logo successfully applied",
    "admin.logo.download.error": "Download error",
    "admin.settings.number.rooms": "Number of halls",
    "admin.settings.room": "Hall",

    "admin.qr.title": "QR code for guests",
    "admin.qr.alt": "QR for restaurant",
    "admin.qr.copy": "copy link",
    "admin.qr.copied": "✓ copied",
    "admin.qr.note": "Guests can scan this code to open your page instantly",

    "admin.link.notfound": "Link not found",

    "admin.table.info": "Table management is available on this page. The status is changed by the pressure hit",

    "admin.prices.temp": "Prices are temporarily unavailable.",

    "admin.forgot.password": "Forgot your password?",

    "admin.success.description": "Click Ok and add another product",

    "order.success": "Item added to cart!",
    "order.error": "The item is already in the shopping cart",




    "popap.product.removal": "Product removal",
    "popap.category.removal": "Remove a category",
    "popap.want.delete.product": "Are you sure you want to delete the product",
    "popap.want.delete.category": "Are you sure you want to delete the category?",

    "admin.settings.guestLang": "Default language for guests",
    "admin.settings.adminLang": "Default language for admin",
    "admin.settings.noteGuest": "This language will be set as default when guests open the page.",
    "admin.settings.noteAdmin": "This language will be set as default in the admin area.",
    "admin.language": "Language",
    "admin.settings.logo": "Establishment logo",
    "admin.settings.logo.text": "Upload your logo (PNG/JPG/WEBP/SVG, up to 2MB). Then click “Save”, this will replace the current logo with the new one.",
    "admin.settings.backtable": "Background image on the screen for selecting tables",
    "admin.settings.backhome": "Home screen background image",
    "admin.settings.backtable.text": "Upload a background image (SVG/PNG/JPG/WEBP). Then click “Save”, this will replace the current background with the new one.",
    "admin.settings.language.visitors": "Main language for visitors to the establishment",
    "admin.settings.language.visitors.text": "This language will be set as the primary language when guests open the page",
    "admin.settings.language.admin": "The main language for your admin panel",
    "admin.settings.language.admin.text": "This language will be set as the default when opening the admin panel",
    "admin.settings.gallery": "Gallery",
    "admin.settings.social": "Social networks",
    "admin.settings.number.tables": "Number of tables",
    "admin.settings.how.many.tables": "How many tables are there in the establishment?",
    "admin.settings.tables.test": "Save the number of tables and return to the previous tab to configure the settings for each table individually",
    "admin.settings.upload.panoramic": "Upload a panoramic image of your facility's hall",
    "admin.settings.table": "Table",
    "admin.settings.table.not.found": "Table not found",
    "admin.settings.contact.details": "Contact details",
    "admin.contacts.company": "Company name",
    "admin.contacts.address": "Address",
    "admin.contacts.phone": "Telephone number",
    "admin.socials.title": "Social media",
    "admin.settings.rooms.hint": "Please indicate the number of rooms in the facility",

    "admin.settable.title": "Step 3. Table numbering",
    "admin.settable.text1": "Each label has a number, place the labels according to the table numbers",
    "admin.settable.text2": "Use the toggle to change the label size",
    "admin.settable.text3": "Save the data for the current table and click on the corresponding icon to switch between tables.",
    "admin.setqr.title": "Your QR codes",
    "admin.setqr.text1": "on this page your messages, menus and QR codes are saved",
    "admin.setqr.text2": "purchasing a BASE plan will automatically generate a QR code and a link to your subdomain name (for example example.best-place.club",
    "admin.setqr.text3": "you can follow the link, copy it, and also save the QR code as an image to your device",
    "admin.setpanorama.title": "Schritt 2. Panoramabild",
    "admin.setpanorama.text1": "Fügen Sie ein Panoramabild hinzu. Es wird empfohlen, leichtgewichtige Dateien (z. B. im WEBP-Format) zu verwenden.",
    "admin.setpanorama.text2": "Wenn das Bild erfolgreich hochgeladen wurde, wird es in der untenstehenden Vorschau angezeigt.",
    "admin.setnumber.title": "Schritt 1. Salzmenge",
    "admin.setnumber.text1": "Choose the number of tables in your establishment",
    "admin.setnumber.text2": "It is recommended to start the setup with one or two tables and then increase the number.",

    "admin.current.logo": "Current logo",
    "admin.add.photo": "here you can add a file",
    "admin.add.file": "file upload formats .xlsx, .xls, .csv",
    "admin.add.file.but": "Add a file",
    "admin.import.format": "Column format: Category / Title / Description / Price",
    "admin.import.follow": "follow the specified column format and prepare a file of the corresponding format",
    "admin.import.BeСareful": "Be careful, previous data will be lost during import",
    "admin.add.photo.but": "Add a photo",
    "admin.add.photo.set": "Add a photo",

    "admin.wizard.step1": "Choose category",
    "admin.wizard.step2": "Name & price",
    "admin.wizard.step3": "Description & photo",
    "admin.wizard.ready": "Ready",
    "admin.wizard.defaultTitle": "Add product",
    "admin.wizard.step1.desc": "Step 1. Choose a category from existing ones or create a new one",
    "admin.wizard.step2.desc": "Step 2. Choose a name for your product in both languages ​​and set a price",
    "admin.wizard.step3.desc": "Step 3. Write a product description in both languages, add an image, and click save",
    "admin.wizard.step1.desc.short": "Schritt 1. Select an existing or new category",
    "admin.wizard.step2.desc.short": "Schritt 2. Add the name and price of the product",
    "admin.wizard.step3.desc.short": "Schritt 3. Describe the product and add a photo",

    "admin.wizard.tab.existing": "Existing",
    "admin.wizard.tab.new": "New",

    "admin.wizard.cat.loading": "Loading…",
    "admin.wizard.cat.empty": "No categories yet. Switch to “New” and create the first one.",

    "admin.form.categoryKeyDe": "Category (KEY/DE)",
    "admin.form.categoryEn": "Category (EN)",
    "admin.form.titleMain": "Product name",
    "admin.form.descMain": "Description of the product",
    "admin.validation.req": "Enter product name",
    "admin.form.titleDe": "Title (DE)",
    "admin.form.titleEn": "Title (EN)",
    "admin.form.nameDe": "Name (DE)",
    "admin.form.nameEn": "Name (EN)",
    "admin.form.price": "Price",
    "admin.form.descDe": "Description (DE)",
    "admin.form.descEn": "Description (EN)",

    "admin.toast.productAdded": "Product added successfully",
    "admin.tooltip.fixFormErrors": "Fix the form errors",

    "admin.validation.firstCharNotDigit": "The first character cannot be a digit.",
    "admin.validation.maxChars": "shorten the product name",
    "admin.validation.chooseCategory": "Choose a category.",
    "admin.validation.chooseCategoryFromList": "Choose a category from the list.",
    "admin.validation.enterCategoryName": "Enter a category name.",
    "admin.validation.enterProductName": "Enter a product name.",
    "admin.validation.priceFormat": "Invalid price format (e.g. 12.50)",
    "admin.validation.enterDescription": "Enter a description.",
    "admin.tarif.apply": "apply",
    "admin.menu.creating": "Сreate menu",
    "admin.choose.template": "Step 1: Choose a template",
    "admin.choose.template2": "Step 2: Check the product lines",
    "admin.choose.atyle": "Choose a menu style. You can change it later",

    "admin.error.tenantNotFound": "No client found for this subdomain.",
    "admin.error.resolveClient": "Failed to resolve client.",
    "admin.error.menuLoad": "Failed to load menu.",
    "admin.error.saveLang": "Failed to save language.",
    "admin.error.clientNotFound": "Client not found on server",
    "admin.error.arrNotFound": "Data array not found for this client",

    "tpl.premium.title": "Premium",
    "tpl.classic.title": "Clasic",
    "tpl.dark.title": "Dark",
    "tpl.minimal.title": "Minimal",
    "tpl.premium.desc": "Top-Seller",
    "tpl.classic.desc": "light",
    "tpl.dark.desc": "dark",
    "tpl.minimal.desc": "minimal",

    "tp2.position.total": "You now have:",
    "tp2.position.punkte": "Menu items",
    "tp2.position.template": "Template",

    "tp3.qr.link": "QR code and menu link",
    "tp3.step3.title": "Step 3: Preview / Publish",
    "admin.tp.progres.publication": "Publication",
    "admin.tp.progres.positionen": "Position",

    "tp4.link.copy": "COPY",
    "tp4.link.copy.ok": "✓ COPIED",

    "admin.tp.publish": "Publish",
    "admin.tp.posting": "posting ...",

    "admin.import.from.excel": "Import menu from Excel",

    "popap.successful.payment": "Successful payment",

    /*--------LANDING-----------*/

    "landing.title": "Digital solutions for restaurants",
    "landing.title.login": "Log in",
    "landing.text": "Launch your restaurant website in minutes!",
    "landing.try.now": "try for free",
    "landing.title.to": "Who is our service suitable for?",
    "landing.title.answer": "First of all, it will be useful for the owners of establishments whose task is to attract new customers and retain old ones",
    "landing.content.title.first": "Online menu with QR code",
    "landing.content.first": "Your visitors can count on an up-to-date menu and prices, just by scanning the QR code, and special offers will increase visitor loyalty to your product",
    "landing.content.title.second": "Online table reservations",
    "landing.content.second": "We present to your advisor a visual online booking of the table using additional panoramic images. If necessary, you can move between adjacent deposit locations",
    "landing.content.title.third": "Atmospheric content",
    "landing.content.third": "Your potential visitors will have the opportunity to view a variety of content: photos of the general interior, videos of top dishes being prepared, and a panoramic view of the visitor hall.",
    "landing.content.title.four": "Increase your check",
    "landing.content.four": "Offer your guests events such as banquets, birthdays, or special offers for complex or everyday orders",
    "landing.request": "We will contact you soon",
    "callback.invalidPhone": "Please enter a valid phone number",
    "landing.enter.number": "YOUR NUMBER",
    "callback.submitError": "The number could not be sent. Please try again",
    "landing.tariff.advance": "Warning",
    "landing.tariff.advance.desc": "You can fill your application with content for free within the selected tariff",
    "landing.tariff.one-time-not-included": "Individual price calculation. There is a contact button in the right corner of the screen. Leave your number and we will contact you",
    "landing.tariff.one-time-services" : "One-time services",
    "landing.tariff.logo-creation": "Logo creation",
    "landing.tariff.selling-images": "Selling product images",
    "landing.tariff.panorama-creation": "Panorama creation",
    
    "demo.video.unsupported": "Your browser does not support video",
    "demo.title.after": "overview of the service",
    "demo.title.accent": "short",
    "demo.title.before": "A",
    "demo.title.total":"about the service",
    "demo.title": "Video overview",

    /*--------tarif--------*/

    "landing.free.first": "Online-Speisekarte per QR-Code verfügbar, Ergebnis innerhalb weniger Minuten.",
    "landing.free.second": "The ability to edit the menu for the current date",
    "landing.free.third": "Access to the menu design designer",
    "landing.basic.first": "A full URL page with menu access via QR code",
    "landing.basic.second": "Online ordering for your visitors",
    "landing.basic.fourth": "Menu with translation into any language",
    "landing.basic.third": "Online table reservations, panoramic photos of your dining room, clickable tables, and real-time display of reserved and available tables",
    "landing.pro.first": "Functionality that allows you to manage price offers, create banners and marketing strategies",
    "landing.pro.second": "The ability to manage the guest loyalty system for the establishment, influence the final result of reviews on Google",
    "landing.pro.third": "",
    "landing.title.free": "Free for 14 days",
    "landing.registerTitle": "Registration",
    "landing.tariff.selection": "Tariff selection",
    "landing.tariff.subdomain": "Subdomain registration",
    "landing.tariff": " / Per Month",
    "landing.your.tariff": "your tariff",
    "landing.your.example": "for example",
    "landing.Subdomain.selection": "Subdomain selection",
    "landing.password": "password",
    "landing.tariff.free": "FREE",
    "landing.tariff.free-description": "to get to know the service",
    "landing.tariff.basic": "BASIC",
    "landing.tariff.basic-description": "basic features to get started",
    "landing.tariff.pro": "PRO",
    "landing.tariff.pro-description": "For advanced users",
    "landing.tariff.selected": "✓ selected",
    "landing.legal.text.start": "I agree to the",
    "footer.legal.terms": "Terms",
    "landing.legal.text.mid": "and",
    "landing.tariff.optional": "One-time services",
    "landing.tariff.one-time-note": "View rates for creating high-quality, selling images",
    "landing.tariff.pro-locked-desc": "This tariff is not available yet",
    "landing.tariff.in-development": "In development",
    "landing.tariff.free-one-time-desc":"for filling your post with high-quality images",

    /*--------footer--------*/

    "footer.legal.privacy": "Privacy",
    "footer.legal.privacy.and": "policy",
    "footer.about": "Platform for restaurants: menu, table reservations, orders, and admin panel.",




    /*--------server--------*/
    "server.common.unknown": "Unknown error.",
    "server.common.serverError": "Internal server error.",
    "server.common.networkError": "Network error. Please try again.",
    "server.common.clientIdMissing": "Error: clientId is missing.",

    "server.login.required": "Email and password are required.",
    "server.login.invalidCredentials": "Invalid email or password.",
    "server.login.signupIncomplete": "Account is not active yet. Finish registration.",
    "server.login.success": "Login successful!",

    "server.register.required": "Email and password are required.",
    "server.register.emailExistsActive": "User with this email already exists. Use Login.",
    "server.register.resume": "Continuing registration.",
    "server.register.success": "Registration successful!",

    "server.signupComplete.success": "Activation successful!",
    "server.signupComplete.error": "Activation failed.",

    "server.subdomain.required": "clientId and subdomain are required.",
    "server.subdomain.planInvalid": "Invalid plan. Allowed: free | basic | pro.",
    "server.subdomain.invalid": "Invalid subdomain (a-z, 0-9, '-', 3–30, no '-' at start/end).",
    "server.subdomain.reserved": "This subdomain is reserved.",
    "server.subdomain.taken": "This subdomain is already taken.",
    "server.subdomain.userNotFound": "User not found.",
    "server.subdomain.success": "Subdomain registered. Redirecting…",
    "server.subdomain.error": "Subdomain registration failed.",

    "landing.loginTitle": "Login",
    "landing.btn.login": "Login",
    "landing.btn.register": "Registration",
    "landing.btn.enter": "Enter",
    "landing.loggingIn": "Signing in…",
    "landing.registering": "Registering…",
    "landing.activating": "Activating…",
    "landing.subdomain.registering": "Registering subdomain…",
    "landing.redirecting": "Redirecting…",
    "landing.legal.required": "Please accept Terms & Privacy.",

    "landing.subdomain.err.empty": "Please enter a subdomain.",
    "landing.subdomain.err.chars": "Only letters, numbers and '-', 3–30 chars.",
    "landing.subdomain.err.hyphen": "Subdomain can’t start or end with '-'.",
    "landing.subdomain.err.reserved": "This subdomain is reserved.",

  "admin.menuLanguages.default": "The language that a visitor to your establishment will see first (by default)",
  "admin.menuLanguages.title": "Menu languages",  
  "admin.menuLanguages.hint": "Select the languages ​​that will be used additionally",
  "common.success": "Success",
  "admin.import.activeLangs": "Active menu languages",
  "admin.import.sourceLangHint": "Excel will be written only in the selected language. Other active languages ​​will remain blank",
  "admin.import.sourceLang": "Specify the language in which the Excel file is written",
  "admin.import.mainLang": "main",
  "booking.date.today": "Today",
  "booking.date.tomorrow": "Tomorrow",
  "booking.room": "Room",

  "front.faq.chat.answer.greeting": "Hello! I can help with reservations, the menu, address, opening hours, and other questions.",
"front.faq.chat.answer.howAreYou": "Thank you, I’m doing well! How can I help you with the restaurant?",
"front.faq.chat.answer.thanks": "You’re welcome! Feel free to ask if you have any other questions.",
"front.faq.chat.answer.goodbye": "Goodbye! We look forward to your visit.",
"front.faq.chat.answer.whoAreYou": "I’m the restaurant’s digital assistant. I help guests with common questions.",
"front.faq.chat.answer.help": "I can help with reservations, the menu, address, phone number, payment, allergens, delivery, and other questions.",
"front.faq.chat.answer.recommendation": "I recommend checking the menu — there you’ll find the current dishes and can choose what suits you best.",
"front.faq.chat.answer.compliment": "Thank you very much! We’re happy to hear that.",

"checkout.button.send": "SEND",
"checkout.button.sending": "Sending ...",
"checkout.button.sent": "Sent",

"checkout.title.order": "ORDER",
"checkout.phone.title": "Enter your phone number",
"checkout.phone.label": "Phone number",

"footer.workingHours": "Working hours",

"admin.offline.title": "No internet connection",
"admin.offline.text": "Check your internet connection. You can continue working automatically once the connection is restored.",
"admin.offline.status": "Waiting for connection…",

};

export default en;